module.exports = __webpack_public_path__ + "static/img/updateFace.8a083436.png";